import type { ButtonColor } from './colors';

export const secondaryColors: Partial<Record<ButtonColor, string>> = {
  'brand-primary': 'border-brand-primary-700 bg-brand-primary-50 text-brand-primary-700 hover:bg-brand-primary-100',
  'brand-secondary':
    'border-brand-secondary-700 bg-brand-secondary-50 text-brand-secondary-700 hover:bg-brand-secondary-100',
  gray: 'border-text-secondary-400 bg-background text-text-secondary-600 hover:bg-text-secondary-100',
  white:
    'border-text-primary-inverse bg-surface-veil-20 text-text-primary-inverse focus-visible:ring-white focus-visible:ring-offset-black hover:bg-surface-veil-30',
};
